/**
 * TermsAndConditions.tsx
 */
export default function TermsAndConditions() {
    return (
        <div>
            <h1>Legal Terms & Conditions of using our services.</h1>
        </div>
    );
}
